import { render, staticRenderFns } from "./AppTopbar.vue?vue&type=template&id=5a131812&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"
import style0 from "./AppTopbar.vue?vue&type=style&index=0&id=5a131812&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a131812",
  null
  
)

export default component.exports